import {
    Dialog,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Grid,
    Typography,
    DialogActions,
    Button,
    TextField,
    Box,
} from "@material-ui/core"
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { useState } from "react"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { desSeleccionaOferente, NuevaCotizacion } from "../../../actions/compras/Cotizaciones"
import { BuscadorOferente } from "./BuscadorOferente"
import { startAlerta } from "../../../actions/ui/alertas";
import { InformacionDocumentacion } from "../../autorizaciones/gestionAuditoria/Menus/InformacionDocumentacion";
import { setSolicitud } from "../../../actions/autorizaciones/Autorizaciones";
import moment from "moment";
export const ModalCotizaciones = (props) => {

    const { oferente } = useSelector((state) => state.compras)
    const [oferentes, setOferentes] = useState([]);
    const dispatch = useDispatch();
    let oferentesEliminar = [];
    const [observaciones, setObservaciones] = useState("");
    const materialesFiltrados = props.materiales
    .flat() 
    .filter(x => x.fechaBaja === null);    

    useEffect(() => {
        dispatch(setSolicitud(props.item))
    }, [props.item]);

    useEffect(() => {
        if (oferente !== null) {
            var oferenteExistente = oferentes.find(x => x.idOferente === oferente.idOferente);
            if (oferenteExistente === undefined) {
                setOferentes(oferentes => oferentes.concat(oferente))
            } else {
                dispatch(startAlerta('El oferente ya está cargado.', "warning", `¡Error!`))
            }
        }
    }, [dispatch, oferente])

    const eliminarOferente = (oferente) => {
        if (oferentes.indexOf(oferente) > -1) {
            if (oferentes.length > 1) {
                oferentesEliminar = oferentes.filter(x => x.idOferente !== oferente.idOferente)
                setOferentes(oferentesEliminar)
            } else {
                oferentesEliminar = oferentes.shift()
                setOferentes([])
            }
        }
    }

    const handleSave = () => {
        dispatch(NuevaCotizacion(props.idSolicitud, oferentes, materialesFiltrados, observaciones,props.closeModalHandler))
        setOferentes([]);
        dispatch(desSeleccionaOferente())
    }
    console.log(props)
    return (
        <Dialog
            fullWidth
            maxWidth={'lg'}
            open={props.open}>
            <DialogTitle style={{ textAlign: 'center' }}>Pedido Cotizacion Orden N° {props.idSolicitud}</DialogTitle>
            <DialogContent>
                <Grid item xs={12} style={{display:'flex', justifyContent:'space-around'}}>
                    <Typography variant="h6">Fecha Cirugía: {moment(props.item?.fechaProgramada).format("DD/MM/YYYY")}</Typography>
                    <Typography variant="h6">Institucion: {props.item.practicas[0]?.efectorFacturacion?.nombreFantasia}</Typography>
                     </Grid>
                <Grid item xs={12}>
                    <Box p={3}>
                    <TextField
                        label='Observaciones'
                        value={observaciones || ""}
                        onChange={(e) => setObservaciones(e.target.value)}
                        multiline={true}
                        rows={4}
                        placeholder="Las observaciones se enviaran en el mail a el/los oferentes seleccionados."
                        style={{width:'100%'}}
                    />
                    </Box>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    <InformacionDocumentacion
                    estadoSolicitud={props.estadosSolicitud}
                        //disabled={true}
                    />
                </Grid>

                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    <Typography variant='h6' style={{ marginTop: '0.5rem' }}>Seleccionar Oferentes</Typography>
                </Grid>
                <Grid item xs={6} style={{ display: 'flex', margin: 'auto' }} >
                    <BuscadorOferente />
                </Grid>
                <Grid>
                    <Grid item xs={8} style={{ display: 'flex', margin: 'auto' }} >
                        {oferentes.length > 0 && (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nombre</TableCell>
                                        <TableCell>CUIT</TableCell>
                                        <TableCell>Mail</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {oferentes.map((item) => (
                                        <TableRow>
                                            <TableCell>{item.razonSocial}</TableCell>
                                            <TableCell>{item.cuit}</TableCell>
                                            <TableCell>{item.mail}</TableCell>
                                            <TableCell><Button onClick={() => eliminarOferente(item)}><DeleteOutlineOutlinedIcon style={{ color: 'red' }} /></Button></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )

                        }
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ display: 'flex', margin: 'auto' }}>
                <Button color="inherit" variant="contained"
                    onClick={() => {
                        dispatch(props.closeModalHandler);
                        setOferentes([]);
                        dispatch(desSeleccionaOferente())
                    }}>
                    Cancelar
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    disabled={oferentes.length === 0 ? true : false}
                    onClick={() => handleSave()}>
                    Solicitar Cotizacion
                </Button>
            </DialogActions>
        </Dialog>
    )
}